import React, { useCallback, useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router";
import {
  getVideoDetails,
  updateVideoDetails,
} from "../../../api/functions/video.api";
import styles from "../../../styles/components/video.module.scss";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  Grid,
  List,
  ListItem,
  Slider,
  styled,
  Container,
} from "@mui/material";
import assest from "../../../json/assest";
import PerfectScrollbar from "react-perfect-scrollbar";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import SubmitterDetails from "../components/SubmitterDetails";

import { useNavigate } from "react-router-dom";
import ApiLoader from "../../Loaders/ApiLoader";
import CopyrightOwnerships from "../components/CopyrightOwnerships";
import {
  clipCopy,
  concatDownloadPath,
  concatHostAndImagePath,
  concatHostAndVideoPath,
  openInNewTab,
} from "../../../lib/functions/utils.lib";
import SubmissionInformation from "../components/SubmissionInformation";
import VideoJS from "../components/VideoJS";
import VideoFeaturedButtons from "../components/VideoFeaturedButtons";

import ReactPlayer from "react-player";
import screenfull from "screenfull";
import VideoFeaturedButtonsCustom from "../components/VideoFeaturedButtonCustoms";
import { findDOMNode } from "react-dom";
import ModalWrapperSmall from "../../../ui/ModalWrapper/ModalWrapperSmall";
import VideoDetails from "../components/VideoDetails";
import VideoDetailsPending from "../components/VideoDetailsPending";
import CustomVideoPlayer from "../components/CustomVideoPlayer";
import HlsPalyer from "../components/HlsPlayer";
import ShowVideoStatus from "../components/ShowVideoStatus";
import HandleVideo from "../components/HandleVideo";
import { getNote } from "../../../api/functions/note.api";
import AdminNotes from "../components/AdminNotes";
import SubmissionUser from "../../SubmissionUser/SubmissionUser";
import PurchaseInformation from "../components/PurchaseInformation";
import BuyerHandleVideo from "../components/BuyerHandleVideo";
import UserMultipleVideoSubmission from "../components/UserMultipleVideoSubmission";
import VideoMessageSection from "../components/VideoMessageSection";
import VideoReleaseModal from "../../VideoReleaseModal/VideoReleaseModal";

const VideoDetailsPage = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  // console.warn("id", id);

  const [bought, setBought] = useState(false);
  // console.warn("bought", bought);
  const {
    data,
    isLoading: isLoadingGet,
    refetch: refetchVideo,
    isRefetching: isRefetchingVideo,
  } = useQuery(["video_details", id], async () => getVideoDetails(id), {
    enabled: id ? true : false,
    onSuccess: (data) => {
      // console.warn("data2", data);
      if (data.buyer) {
        setBought(true);
      } else {
        setBought(false);
      }
    },
  });
  const {
    data: notes,
    isLoading: notesLoading,
    refetch: refetchNote,
  } = useQuery(["video_notes_details", id], async () => getNote(id), {
    enabled: id ? true : false,
  });

  // console.warn("data", data);
  // console.warn("note", notes);

  const [openThisYear, setOpenThisYear] = React.useState(false);
  const [openThisYear1, setOpenThisYear1] = React.useState(false);
  const [openThisYear2, setOpenThisYear2] = React.useState(false);
  const [openThisYear3, setOpenThisYear3] = React.useState(false);

  const handleToggleThisYear = () => {
    setOpenThisYear(!openThisYear);
  };

  const handleToggleThisYear1 = () => {
    setOpenThisYear1(!openThisYear1);
  };

  const handleToggleThisYear2 = () => {
    setOpenThisYear2(!openThisYear2);
  };

  const handleToggleThisYear3 = () => {
    setOpenThisYear3(!openThisYear3);
  };

  //   /***************modal1*****************/

  //   const [open, setOpen] = React.useState(false);
  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };
  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  //   /***************modal2*****************/

  //   const [open1, setOpen1] = React.useState(false);
  //   const handleClickOpen1 = () => {
  //     setOpen1(true);
  //   };
  //   const handleClose1 = () => {
  //     setOpen1(false);
  //   };

  //   /***************modal3*****************/

  //   const [open2, setOpen2] = React.useState(false);
  //   const handleClickOpen2 = () => {
  //     setOpen2(true);
  //   };
  //   const handleClose2 = () => {
  //     setOpen2(false);
  //   };

  //   /***************approveModal*****************/

  const [openApprove, setOpenApprove] = React.useState(false);
  const handleClickOpenApprove = () => {
    setOpenApprove(true);
  };
  const handleCloseApprove = () => {
    setOpenApprove(false);
  };

  /***************ProceedModal*****************/

  const [openProceed, setOpenProceed] = React.useState(false);
  const handleClickOpenProceed = () => {
    setOpenProceed(true);
  };
  const handleCloseProceed = () => {
    setOpenProceed(false);
  };

  /***************DenydModal*****************/

  const [openDeny, setOpenDeny] = React.useState(false);
  const handleClickOpenDeny = () => {
    setOpenDeny(true);
  };
  const handleCloseDeny = () => {
    setOpenDeny(false);
  };

  /***************VideoReleasedModal*****************/

  const [openVideoRelease, setOpenVideoRelease] = React.useState(false);
  const handleClickOpenVideoRelease = () => {
    setOpenVideoRelease(true);
  };
  const handleCloseVideoRelease = () => {
    setOpenVideoRelease(false);
  };

  /*****************************release video modal***************************/

  const [openCopyRightDispute, setOpenCopyRightDispute] = React.useState(false);
  const handleClickOpenCopyRightDispute = () => {
    setOpenCopyRightDispute(true);
  };
  const handleCloseCopyRightDispute = () => {
    setOpenCopyRightDispute(false);
  };

  // const HtmlTooltip = styled(({ className, ...props }) => (
  //   <Tooltip {...props} classes={{ popper: className }} />
  // ))(({ theme }) => ({
  //   [`& .${tooltipClasses.tooltip}`]: {
  //     backgroundColor: "#fff",
  //     color: "rgba(0, 0, 0, 0.87)",
  //     maxWidth: 237,
  //     padding: "11px 13px",
  //     fontSize: theme.typography.pxToRem(12),
  //     boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)",
  //     borderRadius: "10px",
  //     height: "83px",
  //     margin: "0",
  //   },
  // }));

  const { mutate, isLoading } = useMutation(updateVideoDetails, {
    onSuccess: (data) => {
      // console.warn("upadate");
      // const message = "success";
      // alert(message);
      // window.location.reload();
      refetchVideo();
      refetchNote();
    },
    onError: () => {
      console.warn("there was an error");
    },
  });

  const handleUpdate = (status) => {
    // console.warn("{ video_id: data.id, status })", {
    //   id: data.id,
    //   status,
    // });
    mutate({ id: data.id, status });
  };

  return (
    <Box className={styles.VideoPageScroll}>
      <ApiLoader loading={notesLoading || isLoadingGet || isRefetchingVideo} />

      {data && (
        <>
          <VideoReleaseModal
            openVideoRelease={openVideoRelease}
            handleCloseVideoRelease={handleCloseVideoRelease}
            data={data}
          />

          <PerfectScrollbar>
            <Box className={styles.videoWrapper}>
              <Box className={styles.videoWrapperLeft}>
                <Box className="VideocommonBox">
                  <Box className={styles.videoSection}>
                    <Box className={styles.videoBox}>
                      <HlsPalyer
                        source={concatHostAndVideoPath(data.converted_url)}
                      />
                    </Box>
                    <Box className={styles.videoInput}>
                      <input
                        type="text"
                        disabled
                        placeholder={concatDownloadPath(data.video)}
                      />
                      <Button
                        onClick={() => clipCopy(concatDownloadPath(data.video))}
                      >
                        <img
                          src={assest.copyIcon}
                          width={13}
                          height={16}
                          alt=""
                        />
                      </Button>
                    </Box>

                    {bought ? (
                      <>
                        <BuyerHandleVideo
                          data={data}
                          handleUpdate={handleUpdate}
                        />
                      </>
                    ) : (
                      <HandleVideo data={data} handleUpdate={handleUpdate} />
                    )}

                    <VideoMessageSection data={data} />

                    <Box className={styles.downloadButton}>
                      <Button
                        onClick={() =>
                          openInNewTab(concatDownloadPath(data.video))
                        }
                      >
                        <img
                          src={assest.doenloadVideoicon}
                          width={13}
                          height={14}
                          alt=""
                        />{" "}
                        Download Video
                      </Button>
                      <Button>
                        <img
                          src={assest.downloadAssignment}
                          width={14}
                          height={14}
                          alt=""
                        />{" "}
                        Download Redacted Agreement
                      </Button>
                      {data.status == 1 && (
                        <Button
                          className={styles.releaseButton}
                          onClick={handleClickOpenVideoRelease}
                        >
                          <img
                            src={assest.releaseVideoIcon}
                            width={14}
                            height={14}
                            alt=""
                          />{" "}
                          Release Video
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Box>
                {!bought ? (
                  <VideoDetailsPending
                    refetchVideo={refetchVideo}
                    data={data}
                  />
                ) : (
                  <>
                    <Box className={styles.purchedBox}>
                      <p>
                        Asset Was Purchased on behalf of ViralSnare by:{" "}
                        <span> {data.buyer?.name} </span>{" "}
                        <span className={styles.purchedBoxSpan}>
                          (Content Buyer)
                        </span>
                      </p>
                    </Box>
                  </>
                )}
              </Box>

              <Box className={styles.videoWraperRight}>
                {/* <PerfectScrollbar> */}
                <Box className={styles.videoOwner}>
                  <ShowVideoStatus
                    notes={notes}
                    data={data}
                    handleUpdate={handleUpdate}
                    refetchNote={refetchNote}
                  />
                  {/* <SubmissionUser /> */}
                  {data.otherUploadedVideos?.length > 0 && (
                    <UserMultipleVideoSubmission
                      data={data}
                      refetchVideo={refetchVideo}
                    />
                  )}
                  <SubmitterDetails data={data} />
                  {bought ? (
                    <VideoDetailsPending
                      refetchVideo={refetchVideo}
                      data={data}
                    />
                  ) : (
                    <CopyrightOwnerships data={data} />
                  )}
                </Box>
                {/* </PerfectScrollbar> */}
                {bought ? (
                  <>
                    <PurchaseInformation data={data} />
                  </>
                ) : (
                  <>
                    <SubmissionInformation data={data} />
                  </>
                )}
                {bought && (
                  <AdminNotes
                    data={data}
                    notes={notes}
                    refetchNote={refetchNote}
                  />
                )}
                {data?.status == 1 && !bought && (
                  <AdminNotes
                    data={data}
                    notes={notes}
                    refetchNote={refetchNote}
                  />
                )}
              </Box>
            </Box>
          </PerfectScrollbar>
        </>
      )}
    </Box>
  );
};

export default VideoDetailsPage;
